import { ParsedBusinessResult } from './parseResponse';

// At most this many manual lookup retries for the same CUI; after that only the alternatives remain.
export const MAX_LOOKUP_RETRIES = 3;

// Provider rate control: ANAF allows about one request per second, so no retry sooner than this.
export const MIN_RETRY_DELAY_MS = 1000;

/** How long to wait after this answer before the same request may be sent again. Never retried automatically. */
export const retryDelayMs = (result: ParsedBusinessResult): number =>
    result.kind === 'failure' && result.retryAfterSeconds !== undefined
        ? result.retryAfterSeconds * 1000
        : MIN_RETRY_DELAY_MS;

/**
 * Whether a lookup may be tried again. `unknown` is retryable (the generic message says "try again"). A failure only
 * when the server marked it retryable. A shown verification is retryable only when the submit refused it.
 */
export const isLookupRetryable = (result: ParsedBusinessResult, options: { verificationRejected?: boolean } = {}): boolean => {
    switch (result.kind) {
        case 'unknown': return true;
        case 'failure': return result.response.error.retryable;
        case 'eligible': return options.verificationRejected === true;
        default: return false;
    }
};
